import React, { useState, useRef } from "react";
import { FaArrowAltCircleDown, FaStar } from "react-icons/fa";
import "./css/ItinearySection.css";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Row } from "react-bootstrap";

const ItinearySection = ({ data }) => {
    //   console.log("testtest",data);

    const swiperRef = useRef(null);

    const [activeTab, setActiveTab] = useState(null);

    const toggleTab = (tab) => {
        if (activeTab === tab) {
            setActiveTab(null);
        } else {
            setActiveTab(tab);
        }
    };
    return (
        <>
            <div className=" mt-8 ">
                <div>

                    <div className="intineraryMainDiv mt-4 mb-5" id="ltinerary">
                        <h2 className="intineraryMainhead text-[18px] font-[600] mb-4">
                            Itenirary
                        </h2>
                        {/* hs */}
                        <ul id="first-list">
                        {data.packagedetail.package_itinerary.map((item, id) => (
                            <li className="timeline-item" key={id}>
                            <div className="timeline-left">
                                <span className="timeline-day">Day {id + 1}</span>
                            </div>

                            <div className="timeline-center">
                                <span className="timeline-dot"></span>
                                {id !== data.packagedetail.package_itinerary.length - 1 && (
                                <span className="timeline-line"></span>
                                )}
                            </div>

                            <div className="timeline-right">
                                <div className="timeline-header" onClick={() => toggleTab(id)}>
                                <h3 className="timeline-title">{item.title}</h3>
                                <RiArrowDropDownLine
                                    size={30}
                                    className={activeTab === id ? "arrow rotate" : "arrow"}
                                />
                                </div>

                                {activeTab === id && (
                                <div className="timeline-details">
                                    {item.details && (
                                    <div
                                        dangerouslySetInnerHTML={{ __html: item.details }}
                                    ></div>
                                    )}
                                    {/* If you have multiple sub-itineraries in item.Itinerary, render them too */}
                                    {item.Itinerary &&
                                    item.Itinerary.map((dyIti, index) => (
                                        dyIti.UsedType !== "Img" && (
                                        <div
                                            key={index}
                                            className="timeline-subdetails"
                                            dangerouslySetInnerHTML={{ __html: dyIti.Description }}
                                        ></div>
                                        )
                                    ))}
                                </div>
                                )}
                            </div>
                            </li>
                        ))}
                        </ul>


                        {/* hs */}
                        <div className="newiti">

                            {data.packagedetail.package_itinerary.map((item, id) => (
                                <div className="itinerarysecDiv" key={id}>
                                    <button
                                        className="itinerarysecDivbtn1"
                                        onClick={() => toggleTab(item.id)}
                                    >
                                        {/* <div className="itinerarysecDIvMain "> */}
                                        <div className="itinerarysecDiv2">
                                            <div style={{ display: "flex" }}>
                                                <span
                                                    className="itinerarysecDiv2para1"
                                                    style={{ marginRight: "10px" }}
                                                >
                                                    Day {id + 1}
                                                </span>
                                                <span className="itinerarysecDiv2para2">
                                                    {item.title}
                                                </span>
                                            </div>
                                            <div>
                                                {activeTab === item.id ? (
                                                    <FiMinusCircle />
                                                ) : (
                                                    <FiPlusCircle />
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            {/* <RiArrowDropDownLine size={25} color="#1a4f87" /> */}
                                            {/* </div> */}
                                        </div>
                                    </button>
                                    {activeTab === item.id && (
                                        <div className="mt-2">
                                            <p
                                                className="itinerarysecDiv2para3"
                                                dangerouslySetInnerHTML={{ __html: item.details }}
                                            ></p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>


                    <div id="inclusion">
                        <h2 className="itineraryInclusion">Inclusions</h2>
                        <ul className="itineraryInclusionUnder">
                            {data?.packagedetail?.package_inclusions
      ?.filter((item) => item && item.trim() !== "")
      .map((item, index) => (
                                <div key={index} className="itineraryInclusionInnerDiv">
                                    <span className=""> ✔ </span>
                                    <li dangerouslySetInnerHTML={{ __html: item }}></li>
                                </div>
                            ))}
                        </ul>
                    </div>
                    <div id="exlcusion">
                        <h2 className="itineraryInclusion">Exclusion</h2>

                        <ul className="itineraryInclusionUnder">
                           {data?.packagedetail?.package_exclusions
      ?.filter((item) => item && item.trim() !== "")
      .map((item, index) => (
                                <div key={index} className="itineraryInclusionInnerDivs">
                                    <span className=""> ⨯ </span>
                                    <li dangerouslySetInnerHTML={{ __html: item }}></li>
                                </div>
                            ))}
                        </ul>
                    </div>
                    {
                        data.packagedetail.hotel.length > 0 &&(
  <div className="itineraryHotelDetailMainHead" id="Hotels">
                        <h2 className="itineraryHotelDetailHead">Hotel Details</h2>
                        {data.packagedetail.hotel.map((item) => (
                            <div className="itineraryHotelDetailMain">
                                <div className="itineraryHotelDetailMain2">
                                    <Row>
                                        <Swiper
                                            slidesPerView={1}
                                            spaceBetween={40}
                                            pagination={{ clickable: true }}
                                            modules={[Autoplay]}
                                            autoplay
                                            loop
                                            className="mySwiper"
                                            style={{ paddingBottom: "40px" }}
                                            onSwiper={(swiper) => {
                                                swiperRef.current = swiper;
                                            }}
                                        >

                                            {item.hotel_gallery.map((itemx, index) => (
                                                <SwiperSlide key={index}>
                                                    <img
                                                        src={itemx.image}
                                                        className="ItineraryHotelDetailMainImage"
                                                        alt={item.image_alt}
                                                    />

                                                </SwiperSlide>
                                            ))}

                                        </Swiper>
                                    </Row>
                                </div>
                                <div className="itineraryHotelDetailMain3">
                                    <div className="itineraryHotelDetailMain3Inner">
                                        <h3 className="itineraryHotelDetailMain3Innerh3 ">
                                            {item.name}
                                        </h3>
                                        <p className="itineraryHotelDetailpara1">Include a trip</p>
                                    </div>
                                    <div className="itineraryHotelDetailStar">
                                        <FaStar size={13.5} color="#f5b800" />
                                        <FaStar size={13.5} color="#f5b800" />
                                        <FaStar size={13.5} color="#f5b800" />
                                    </div>
                                    <div>
                                        <p className="itineraryHotelDetailpara3">
                                            <span style={{ fontWeight: "600" }}>Address: </span>{" "}
                                            {item.address}
                                        </p>
                                    </div>
                                    <div style={{ textAlign: "end", width: "100%" }}>
                                        {/* <p className="itineraryHotelDetailparaIn">Include a trip</p> */}
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        ))}
                    </div>
                        )
                    }
                  
                    <div id="term-condition">
                        <h2 className="itineraryHotelDetailHead">Our Policy</h2>
                        <div>
                            <ul
                                className="itineraryInclusionUnderss"
                                style={{ listStyleType: "circle" }}
                            >
                               {data?.tour_policy
      ?.filter((item) => item && item.trim() !== "")
      .map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div>
                        <h2 className="itineraryHotelDetailHead">Cancelation Policy</h2>
                        <div>
                            <ul
                                className="itineraryInclusionUnderss"
                                style={{ listStyleType: "circle" }}
                            >
                               {data?.cancelation_policy
      ?.filter((item) => item && item.trim() !== "")
      .map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div>
                        <h2 className="itineraryHotelDetailHead">Payment Policy</h2>
                        <div>
                            <ul
                                className="itineraryInclusionUnderss"
                                style={{ listStyleType: "circle" }}
                            >
                             {data?.payment_policy
      ?.filter((item) => item && item.trim() !== "")
      .map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default ItinearySection;
